module.exports = __webpack_public_path__ + "img/7ea92d8.png";